import React from 'react'
import Header from '../../../../googleAd/shared/sections/Header'
import { FirstView } from '../../../shared/sections/FirstView'
import EntryForm from '../../../shared/forms/EntryForm'
import { nagasakiConfig } from './config.ts'
import { StepProvider } from '@/components/Context/StepContext'
import styles from './InstagramNagasakiFormPage.module.css'
import { NagasakiSpLandingPageProps } from './types.ts'
import { useAbTestGtm } from '@/components/utils/abTest'

const InstagramNagasakiFormPage: React.FC<NagasakiSpLandingPageProps> = ({ prefectures }) => {
    const { dataViewLabel } = useAbTestGtm()

    return(
        <div className={styles.InstagramNagasakiFormPageWrap}>
            <StepProvider
                initialFormData={{
                    preferLineContact: true,
                    agreeTerms: true
                }}
                initialTouchedFields={{
                    preferLineContact: true,
                    agreeTerms: true,
                    channel: true
                }}
            >
                <Header id='renewal_top' dataViewLabel={dataViewLabel('HD')} />
                <FirstView dataViewLabel={dataViewLabel('CT_FirstView')}/>
                <div className={styles.formWrap}>
                    <EntryForm
                        prefectures={prefectures}
                        config={nagasakiConfig}
                    />
                </div>
            </StepProvider>
        </div>
    )
}

export default InstagramNagasakiFormPage
